import React, { ChangeEvent, useContext, useEffect, useState } from "react";
import "./ProductGroupExtendedSelectionModal.scss";
import OwButton from "../../shared/OwButton/OwButton";
import IErrorDTO from "../../../models/DTO/IErrorDTO";
import OwTitle from "../../shared/OwTitle/OwTitle";
import OwLabel from "../../shared/OwLabel/OwLabel";
import IOrder from "../../../models/IOrder";
import ICatalog_Item from "../../../models/ICatalog_Item";
import OwS3ImageViewer from "../../shared/OwS3ImageViewer/OwS3ImageViewer";
import IImageSizeEnum from "../../../models/IImageSizeEnum";
import styled from "styled-components";
import IGroupItem from "../../../models/IGroupItem";
import * as _ from "lodash-es";
import { OwFnInput } from "../../shared/OwFnInput/OwFnInput";
import SupplierContext from "../../../contexts/SupplierContext";
import IWarehouse from "../../../models/IWarehouse";
import UIService from "../../../services/UIService";
import { NumericFormat } from "react-number-format";
import OrderEntryService from "../../../services/OrderEntryService";
import IProductGroupSelection from "../../../models/IProductGroupSelection";
import { Socket } from "socket.io-client";
import INotification from "../../../models/INotification";
import NotificationPositionEnum from "../../../models/NotificationPositionEnum";
import NotificationLevelEnum from "../../../models/NotificationLevelEnum";
import { IAddBulkItems } from "@models/IAddBulkItems";
import INewOrder_Item from "@models/INewOrder_Item";

type Props = {
    closeModalFn: () => void;
    socket: Socket;
    notifyFn: (data: IErrorDTO | null, _notification?: any, isFormatted?: boolean) => void;
    order: IOrder;
    catalogItem: ICatalog_Item;
    warehouses: IWarehouse[];
    setSelections: (selections: IProductGroupSelection[]) => void;
    addBulkItems?: (items: IAddBulkItems[]) => void;
    addToCart?: (items: IAddBulkItems[]) => void;
};

export const ProductGroupExtendedSelectionModal: React.FC<Props> = (props) => {
    const supplierModel = useContext(SupplierContext);

    const getInputValues = () => {
        const obj: { [key: string]: number } = {};

        for (const groupItem of props.catalogItem.group_items || []) {
            if (groupItem.guid) {
                // TODO set to the proper value based on prop value passed in?
                obj[groupItem.guid] = 0;
            }
        }

        return obj;
    };

    const [groupItems, setGroupItems] = useState<IGroupItem[]>([]);
    const [isLightMode, setIsLightMode] = useState(UIService.isMainViewLight());
    const [showInventoryDetails, setShowInventoryDetails] = useState(true);
    const [inputValues, setInputValues] = useState(getInputValues());

    useEffect(() => {
        const _groupItems = _.sortBy(props.catalogItem.group_items || [], ["group_sequence", "asc"]);

        let numInventoryGroupItems = 0;

        if (props.catalogItem.group_items) {
            for (const item of props.catalogItem.group_items) {
                if (item.has_inventory) {
                    numInventoryGroupItems++;
                }
            }

            if (numInventoryGroupItems === props.catalogItem.group_items.length) {
                setShowInventoryDetails(true);
            } else {
                if (!numInventoryGroupItems) {
                    setShowInventoryDetails(false);
                } else {
                    setShowInventoryDetails(true);
                }
            }
        }

        setGroupItems(_groupItems);
    }, []);

    const closeModal = () => {
        props.closeModalFn();
    };

    const create = () => {
        const selections: IProductGroupSelection[] = [];
        const itemsToAdd: Partial<INewOrder_Item>[] = [];

        let allowAdd = true;

        const keys = Object.keys(inputValues);

        for (const guid of keys) {
            if (inputValues[guid] > 0) {
                let itemSku = "";

                for (const groupItem of groupItems) {
                    if (groupItem.guid === guid) {
                        itemSku = groupItem.sku || "";

                        const item: Partial<INewOrder_Item> = {
                            ...groupItem,
                            qty: inputValues[guid],
                        };

                        const inventoryDetail = OrderEntryService.doInventoryValidation(
                            groupItem as ICatalog_Item,
                            inputValues[guid],
                            props.order.Order_Items,
                            supplierModel,
                            props.order,
                            0
                        );

                        // console.log("create inventoryDetail: ", inventoryDetail);

                        if (!inventoryDetail.enableAdd) {
                            allowAdd = false;
                        }

                        itemsToAdd.push(item);
                    }
                }

                const selection: IProductGroupSelection = {
                    itemGuid: guid,
                    qty: inputValues[guid],
                    itemSku,
                };

                selections.push(selection);
            }
        }

        if (!allowAdd) {
            const notification: INotification = {
                message: "product_selections_exceed_inventory",
                position: NotificationPositionEnum.bc,
                level: NotificationLevelEnum.success,
            };

            props.notifyFn(null, notification);
        } else {
            // props.setSelections(selections);
            // if (props.addBulkItems) {
            //     props.addBulkItems(itemsToAdd.map((item) => ({
            //         item: {
            //             ...item,
            //             catalog_item_id: item.catalog_item_id!,
            //             Catalog_Item: item as ICatalog_Item,
            //         },
            //         kitDetails: [],
            //         kitBuilderData: undefined,
            //         itemOptionValues: [],
            //     })));
            //     props.closeModalFn();
            // }
            // if (props.addToCart) {
            //     props.addToCart(itemsToAdd.map((item) => ({
            //         item: {
            //             ...item,
            //             Catalog_Item: item as ICatalog_Item,
            //         },
            //         kitDetails: [],
            //         kitBuilderData: undefined,
            //         itemOptionValues: [],
            //     })));
            //     props.closeModalFn();
            // }
        }
    };

    const decrementQty = (groupItem: IGroupItem) => {
        const _inputValues = {
            ...inputValues,
        };

        let decrementVal = 1;

        if (groupItem.unit_incr_qty) {
            decrementVal = groupItem.unit_incr_qty;
        }

        let newValue = _inputValues[groupItem.guid!] - decrementVal;

        if (newValue < 0) {
            newValue = 0;
        }

        _inputValues[groupItem.guid!] = newValue;

        const item = groupItem as ICatalog_Item;

        const details = OrderEntryService.doInventoryValidation(item, newValue, props.order.Order_Items, supplierModel, props.order, 0);

        if (details.enableAdd) {
            _inputValues[item.guid] = details.qty;
        } else {
            if (!groupItem.allow_backorder) {
                if (details.qty - details.maxQty > 0) {
                    _inputValues[item.guid] = details.maxQty;
                }
            }
        }

        setInputValues(_inputValues);
    };

    const incrementQty = (groupItem: IGroupItem) => {
        const _inputValues = {
            ...inputValues,
        };

        let incrementVal = 1;

        if (groupItem.unit_incr_qty) {
            incrementVal = groupItem.unit_incr_qty;
        }

        const newValue = _inputValues[groupItem.guid!] + incrementVal;

        _inputValues[groupItem.guid!] = newValue;

        const item = groupItem as ICatalog_Item;

        const details = OrderEntryService.doInventoryValidation(item, newValue, props.order.Order_Items, supplierModel, props.order, 0);

        if (details.enableAdd) {
            _inputValues[item.guid] = details.qty;
        } else {
            if (!groupItem.allow_backorder) {
                if (details.qty - details.maxQty > 0) {
                    _inputValues[item.guid] = details.maxQty;
                }
            }
        }

        setInputValues(_inputValues);
    };

    const handleQtyChange = (groupItem: IGroupItem, e: ChangeEvent<any>) => {
        // any
        const value = Number(e.target.value || 0);
        const name = e.target.name;

        const item = groupItem as ICatalog_Item;

        const details = OrderEntryService.doInventoryValidation(item, value, props.order.Order_Items, supplierModel, props.order, 0);

        console.log("doInventoryValidation: ", details);

        const _inputValues = {
            ...inputValues,
        };

        if (details.enableAdd) {
            console.log("enableAdd qty: ", details.qty);
            _inputValues[item.guid] = details.qty;
        } else {
            if (!groupItem.allow_backorder) {
                if (details.qty - details.maxQty > 0) {
                    console.log("dont enable add, set to maxQty", details.maxQty);
                    _inputValues[item.guid] = details.maxQty;
                }
            }
        }

        // console.log(_inputValues);

        setInputValues(_inputValues);
    };

    const getWarehouseQtyOnHand = (warehouseId: number, groupItem: IGroupItem): number => {
        let qtyOnHand = 0;

        for (const itemMap of groupItem.Warehouse_Catalog_Items_Maps || []) {
            if (itemMap.warehouse_id === warehouseId) {
                qtyOnHand = itemMap.qty_on_hand;
            }
        }

        return qtyOnHand;
    };

    const getQtyOnHandViewer = (groupItem: IGroupItem) => {
        if (showInventoryDetails) {
            if (supplierModel.has_warehouses) {
                return (
                    <>
                        {props.warehouses
                            .filter((warehouse) => !warehouse.is_hidden)
                            .map((warehouse) => {
                                let className = "align-middle";

                                if (warehouse.id === props.order.shipping_warehouse_id) {
                                    className += " border border-primary";
                                }

                                return (
                                    <td key={warehouse.guid} className={className}>
                                        <NumericFormat
                                            renderText={(formattedValue: string) => {
                                                return (
                                                    <div
                                                        className={
                                                            "align-items-center justify-content-center justify-items-center d-flex h-100 w-100"
                                                        }>
                                                        {formattedValue}
                                                    </div>
                                                );
                                            }}
                                            fixedDecimalScale={true}
                                            decimalScale={supplierModel.qty_precision || 2}
                                            thousandSeparator={true}
                                            displayType={"text"}
                                            value={getWarehouseQtyOnHand(warehouse.id, groupItem)}
                                        />
                                    </td>
                                );
                            })}
                    </>
                );
            } else {
                if (groupItem.has_inventory) {
                    return <div>{groupItem.qty_on_hand || 0}</div>;
                } else {
                    return <div>--</div>;
                }
            }
        } else {
            return null;
        }
    };
    const getQtyInput = (groupItem: IGroupItem) => {
        let isInputDisabled = false;

        if (supplierModel.has_warehouses) {
            const _warehouse = props.warehouses.find((warehouse) => warehouse.id === props.order.shipping_warehouse_id);

            if (_warehouse) {
                const warehouseQty = getWarehouseQtyOnHand(_warehouse.id, groupItem);

                if (warehouseQty === 0) {
                    isInputDisabled = true;
                }
            }
        }

        return (
            <QtyButtonTd>
                {/*<div>{inputValues[item.guid!]}</div>*/}
                <QtyButtonGroup className={"input-group"}>
                    <div className={"input-group-prepend"}>
                        <OwButton
                            centerIconClass={"fas fa-minus"}
                            fn={() => decrementQty(groupItem)}
                            disabled={isInputDisabled}
                            disableDblClickPrevention={true}
                        />
                    </div>
                    <OwFnInput
                        fn={(e: ChangeEvent<any>) => handleQtyChange(groupItem, e)}
                        name={"qty"}
                        value={inputValues[groupItem.guid!] || 0}
                        enableDebounce={true}
                        onBlurValidation={true}
                        disabled={isInputDisabled}
                    />
                    <div className={"input-group-append"}>
                        <OwButton
                            centerIconClass={"fas fa-plus"}
                            fn={() => incrementQty(groupItem)}
                            disabled={isInputDisabled}
                            disableDblClickPrevention={true}
                        />
                    </div>
                </QtyButtonGroup>
            </QtyButtonTd>
        );
    };

    return (
        <ModalContainer className={"ProductGroupExtendedSelectionModal p-2"}>
            <div className={"w-100"}>
                <div className={"d-flex justify-content-between"}>
                    <OwTitle leftIconName={"fad fa-pencil"} title={"modify_product_selections"} tag={"h3"} />
                    <div>
                        <OwButton className={"btn-danger"} centerIconClass={"fas fa-times"} fn={closeModal} />
                    </div>
                </div>
            </div>

            <MainContentWrapper>
                <div>
                    <OwLabel title={"shipping_warehouse"} postText={":"} className={"me-2"} />
                    {props.order.Shipping_Warehouse?.name}

                    <div className={"text-end"}>
                        <OwButton title={"add"} fn={create} btnSizeClass={"btn"} className={"btn-warning"} leftIconClass={"fas fa-plus"} />
                    </div>
                </div>

                <DetailTopDiv>
                    <OwS3ImageViewer
                        imageIndex={IImageSizeEnum.THUMB}
                        catalogItem={props.catalogItem}
                        includeAllImages={true}
                        modalIndex={IImageSizeEnum.MEDIUM}
                        imageSeq={0}
                        isMicroView={true}
                        hideEmptyImage={false}
                    />

                    <div className={"d-flex justify-content-around"}>
                        <div>
                            <div>
                                <OwLabel title={"name"} className={"me-2 mb-2"} postText={":"} />
                                {props.catalogItem.name}
                            </div>
                            <div>
                                <OwLabel title={"sku"} className={"me-2 mb-2"} postText={":"} />
                                {props.catalogItem.sku}
                            </div>
                            <div className={"mb-2"}>
                                <OwLabel title={"description"} postText={":"} />
                                <div dangerouslySetInnerHTML={{ __html: props.catalogItem.description || "" }}></div>
                            </div>
                        </div>
                        <div>
                            {(supplierModel.Supplier_Integration.QBD_Custom_Fields || [])
                                .filter((item) => item.display_only)
                                .map((item, index) => {
                                    // @ts-expect-error
                                    const displayItem = (props.catalogItem.display_fields || []).find(
                                        (displayField) => item.name === displayField.name
                                    );

                                    if (displayItem?.value.length) {
                                        return (
                                            <div key={item.guid} className={"d-flex"}>
                                                <OwLabel skipTranslate={true} title={item.name} className={"me-2 mb-2"} postText={":"} />
                                                <div>{displayItem?.value}</div>
                                            </div>
                                        );
                                    } else {
                                        return null;
                                    }
                                })}
                        </div>
                    </div>
                </DetailTopDiv>

                <ProductGroupTableContainer>
                    <ProductGroupTable
                        className={"table table-borderless table-striped bg-transparent " + (isLightMode ? "" : "table-dark")}>
                        <thead>
                            <tr>
                                <th>
                                    <OwLabel title={"sku"} />
                                </th>
                                {supplierModel.show_description_in_product_group_modal ? (
                                    <th>
                                        <OwLabel title={"description"} />
                                    </th>
                                ) : null}
                                {showInventoryDetails ? (
                                    <th
                                        className={"text-center"}
                                        colSpan={props.warehouses.filter((warehouse) => !warehouse.is_hidden).length}>
                                        <OwLabel title={"qoh"} />
                                    </th>
                                ) : null}
                                <th className={"text-end"}>
                                    <OwLabel title={"qty"} />
                                </th>
                            </tr>
                            {showInventoryDetails && props.warehouses.length ? (
                                <tr>
                                    <td></td>
                                    {props.warehouses
                                        .filter((warehouse) => !warehouse.is_hidden)
                                        .map((warehouse) => {
                                            return <th key={warehouse.guid}>{warehouse.name}</th>;
                                        })}
                                    <td></td>
                                </tr>
                            ) : null}
                        </thead>

                        <tbody>
                            {groupItems.map((item) => {
                                return (
                                    <tr key={item.guid}>
                                        <td>
                                            <div>{item.sku}</div>
                                            {item.has_inventory ? (
                                                <div className={"text-small"}>
                                                    <OwLabel title={"total_qoh"} postText={":"} className={"me-2"} />
                                                    {item.qty_on_hand}
                                                </div>
                                            ) : null}
                                        </td>
                                        {supplierModel.show_description_in_product_group_modal ? (
                                            <td>
                                                <div dangerouslySetInnerHTML={{ __html: item.description || "" }} />
                                            </td>
                                        ) : null}
                                        {getQtyOnHandViewer(item)}
                                        {getQtyInput(item)}
                                    </tr>
                                );
                            })}
                        </tbody>
                    </ProductGroupTable>
                </ProductGroupTableContainer>
            </MainContentWrapper>
        </ModalContainer>
    );
};

const ModalContainer = styled.div`
    max-height: 100%;
    padding-bottom: 3rem !important;
    display: flex;
    flex-direction: column;
`;

const DetailTopDiv = styled.div`
    display: grid;
    grid-template-columns: 0.25fr 1fr;
    grid-column-gap: 1rem;
    margin-top: 2rem;
`;

const GroupSectionDiv = styled.div`
    display: grid;
`;

const GroupSectionHeader = styled.div`
    font-weight: bold;
    display: grid;
    grid-column-gap: 1rem;
    grid-template-columns: 1fr 1fr 1fr;
`;

const GroupItemDiv = styled.div`
    display: grid;
    grid-column-gap: 1rem;
    grid-template-columns: 1fr 1fr 1fr;
`;

const WarehouseWrapperDiv = styled.div`
    display: flex;
`;

const QtyOnHandWrapper = styled.div`
    display: flex;
    width: 100%;
`;

const QtyButtonGroup = styled.div`
    display: flex;
    align-items: end;
    justify-content: end;
`;

const ProductGroupTableContainer = styled.div`
    overflow-y: scroll;
    max-height: 80%;
`;

const ProductGroupTable = styled.table`
    border-spacing: 0 1rem;
    border-collapse: separate;
`;

const QtyButtonTd = styled.td`
    vertical-align: middle !important;
    text-align: right;
`;

const MainContentWrapper = styled.div`
    overflow: hidden;
    max-height: 100%;
    display: flex;
    flex-direction: column;
`;
